import React from 'react';
import ReactDOM from 'react-dom';
import WebSocketManager from './WebSocketManager';
export default class Gongqi_ProgressBar extends React.Component
{
	static parentDiv;
	static show(body,win=null)
	{
		if(body.modal == "modalGlobal" || body.modal == "modalNone")
		{
			Gongqi_ProgressBar.parentDiv = document.getElementById("gongqi_globalProgress");
			return ReactDOM.render(<Gongqi_ProgressBar body = {body}/>,Gongqi_ProgressBar.parentDiv);
		}
		else if(body.modal == "modalSelf")
		{

			if(win)
			{
				Gongqi_ProgressBar.parentDiv = win.document.getElementById("gongqi_globalProgress");
				return ReactDOM.render(<Gongqi_ProgressBar body = {body}/>,Gongqi_ProgressBar.parentDiv);
			}

			var popIframes = $("#formModal iframe");
			if(popIframes.length>0)
			{
				iframe = popIframes.get(popIframes.length-1);
				let win;
				try
				{
					win = iframe.window || iframe.contentWindow;
				}
				catch(e){}
				if(win)
				{
					Gongqi_ProgressBar.parentDiv = win.document.getElementById("gongqi_globalProgress");
					return ReactDOM.render(<Gongqi_ProgressBar body = {body}/>,Gongqi_ProgressBar.parentDiv);
				}
			}
			else
			{
				var arr = $("#g_tab_content>div.tab-pane.active iframe");
				if(arr.length>0)
				{
					var iframe = arr.get(0);
					let win;
					try
					{
						win = iframe.window || iframe.contentWindow;
					}
					catch(e){}
					if(win)
					{
						Gongqi_ProgressBar.parentDiv = win.document.getElementById("gongqi_globalProgress");
						return ReactDOM.render(<Gongqi_ProgressBar body = {body}/>,Gongqi_ProgressBar.parentDiv);
					}
						
				}
			}
		}
		
    }
    
    constructor(props) {
        super(props);

        this.state = {
            title:this.props.body.title,
            total:this.props.body.total,
            loaded:this.props.body.loaded,
			text:this.props.body.text,
			modal:this.props.body.modal,
			closeable:this.props.body.closeable,
			size:"normal"
        }

    }

	closeHandler(focus = false)
	{
		WebSocketManager.progressBar = null;
		
		ReactDOM.unmountComponentAtNode(Gongqi_ProgressBar.parentDiv);
		$(this.modalDiv).remove();

		if(focus && typeof(window.switchToCurrent) == "function")
			window.switchToCurrent();
	}

	minHandler(e)
	{
		this.setState({size:"min"});
	}

	restoreHandler()
	{
		this.setState({size:"normal"});
	}

	keyDownHandler = (e) =>
	{
		return;
		if(e.keyCode == 13) 
			this.query();
		else if(e.keyCode == 27)
		{
			this.closeHandler(true);
			e.preventDefault();
			e.stopImmediatePropagation();
		}
	}

	componentDidMount()
	{
		//$(this.modalDiv).draggable({handle: ".modal-header"});
	}

	componentWillUnmount()
	{
		//TODO如果没有unmountComponentAtNode手动调用，通过remove并没有调用卸载询问函数 对于该类场景 应如何设计？
		
    }
    
    shouldComponentUpdate(nextProps, nextState)
    {
        if(!nextState.title)
            nextState.title = this.state.title;
        if(!nextState.text)
            nextState.text = this.state.text;
        if(!nextState.total)
            nextState.total = this.state.total;
        if(!nextState.loaded)
            nextState.loaded = this.state.loaded;
        return true;
    }

	findKeyDownHandler(e)
	{
		
	}

	getIconDom()
	{
		return	this.state.closeable?
					<i className="fa fa-close" style={{fontSize:"15px",cursor:"pointer",position:"absolute",top:"4px",right:"3px"}} onClick={this.closeHandler.bind(this)}></i>
					:
					(
						this.state.size=="normal"?
							<i className="fa fa-minus" style={{fontSize:"15px",cursor:"pointer",position:"absolute",top:"4px",right:"3px"}} onClick={this.minHandler.bind(this)}></i>
							:
							<i className="fa fa-reply" style={{fontSize:"15px",cursor:"pointer",position:"absolute",top:"4px",right:"3px"}} onClick={this.restoreHandler.bind(this)}></i>
					)
	}

	render()
	{
		if(this.state.modal != "modalNone")
		{
			return 	(<div className="modal" style={{display:"flex",justifyContent:"center"}} ref={node => this.modalDiv = node} onKeyDown={this.findKeyDownHandler.bind(this)}>
					<div style={{alignSelf:"center",border:"2px solid #e5e5e5",borderRadius:"2px",width:'200px'}}>
		              <div  className="modal-header" style={{background:"#ffffff",position:"relative",width:"auto",paddingLeft:"3px",paddingTop:"3px",paddingBottom:"5px",position:"relative"}}>
		                <h5 className="modal-title" style={{marginRight:"10px"}}>{this.state.title}</h5>
		                {
							this.state.closeable?
							<i className="fa fa-close" style={{fontSize:"15px",cursor:"pointer",position:"absolute",top:"4px",right:"3px"}} onClick={this.closeHandler.bind(this)}></i>
							:
							null
						}
		              </div>
                      <div style={{display:'flex',flexDirection:'column',alignItems:'stretch',backgroundColor:'#fff'}}>
                          
						  <div style={{background:'url("./images/30.gif") no-repeat',marginTop:'10px',marginBottom:'10px',height:'25px'}}></div>
                          <div style={{position:'relative'}}>
                            <progress style={{width:'100%',height:'20px'}} max={this.state.total?this.state.total:0} value={this.state.loaded>0?this.state.loaded:0}>您的浏览器不支持progress元素</progress>
                            <div style={{position:'absolute',bottom:'5px',left: '0px',right:'0px',textAlign:'center'}}>
                               {this.state.text?this.state.text:(this.state.loaded + "/" + this.state.total)}
                            </div>
                          </div>
                          
                      </div>
		            </div>
		         </div>
		        );
		}
		else
		{
			let outterStyle = this.state.size=="normal"?{display:"flex",justifyContent:"center",position:'absolute',top:'40%',left:'40%'}:{display:"flex",justifyContent:"center",position:'absolute',bottom:'30px',right:'3px'};
			let bodyStyle = this.state.size=="normal"?{display:'flex',flexDirection:'column',alignItems:'stretch',backgroundColor:'#fff'}:{display:'none',flexDirection:'column',alignItems:'stretch',backgroundColor:'#fff'};
			let iconDom = this.getIconDom();
			return 	(<div style={outterStyle} ref={node => this.modalDiv = node} onKeyDown={this.findKeyDownHandler.bind(this)}>
					<div style={{alignSelf:"center",border:"2px solid #e5e5e5",borderRadius:"2px",width:'200px'}}>
		              <div className="modal-header" style={{background:"#ffffff",position:"relative",width:"auto",paddingLeft:"3px",paddingTop:"3px",paddingBottom:"5px",position:"relative"}}>
		                <h5 className="modal-title" style={{marginRight:"10px"}}>{this.state.title}</h5>
		                {
							iconDom
						}
		              </div>
                      <div style={bodyStyle}>
						  <div style={{background:'url("./images/30.gif") no-repeat',marginTop:'10px',marginBottom:'10px',height:'25px'}}></div>
                          <div style={{position:'relative'}}>
                            <progress style={{width:'100%',height:'20px'}} max={this.state.total?this.state.total:0} value={this.state.loaded>0?this.state.loaded:0}>您的浏览器不支持progress元素</progress>
                            <div style={{position:'absolute',bottom:'5px',left: '0px',right:'0px',textAlign:'center'}}>
                               {this.state.text?this.state.text:(this.state.loaded + "/" + this.state.total)}
                            </div>
                          </div>
                          
                      </div>
		            </div>
		         </div>
		        );
		}

		
	}
}


// WEBPACK FOOTER //
// ./src/websocket/Gongqi_ProgressBar.js